import Vendors from "components/Vendors/Vendor";

const VendorScreen = () => {
    return <Vendors />;
};

export default VendorScreen;
